import { useMutation } from "react-query";
import InternalStudyListService from "@services/internal-study-list-service";
import { InternalTrainingTraineesToFinish } from "@interfaces/store/internal-list-store-types";

export const useProcessMembersToFinishMutation = () => {
  return useMutation(InternalStudyListService.finish);
};
